/* eslint-env browser */
import { useEffect } from 'react';

/**
 * Custom BootAnim for Meet at the Mirror app
 * Uses the brand's SVG logo with luxury animations
 */

const stylesheet = `
	@keyframes matm-logo-rotate {
		to {
			transform: rotate(360deg);
		}
	}

	@keyframes matm-logo-pulse {
		0%, 100% {
			opacity: 0.8;
			transform: scale(1);
		}
		50% {
			opacity: 1;
			transform: scale(1.05);
		}
	}

	@keyframes matm-background-shimmer {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}

	.matm-boot-anim-wrapper {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: linear-gradient(135deg, #2d2f71 0%, #2d2f71 20%, #7a1544 100%);
		background-size: 400% 400%;
		animation: matm-background-shimmer 8s ease-in-out infinite;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.matm-logo-container {
		position: relative;
		width: 300px;
		height: 300px;
		animation-NONE: matm-logo-rotate 12s linear infinite;
		transform: scale(10);
	}

	@media (prefers-reduced-motion: reduce) {
		.matm-logo-container {
			animation-name: none;
		}
	}

	@media (min-width: 640px) {
		.matm-logo-container {
			transform: scale(5);
		}
	}

	.matm-logo-paths {
		animation: matm-logo-pulse 3s ease-in-out infinite;
		transform-origin: center;
	}

	.matm-logo-svg {
		width: 100%;
		height: 100%;
		filter: drop-shadow(0 0 20px rgba(225, 201, 160, 0.3));
	}

	@media (max-width: 640px) {
		.matm-logo-container {
			width: 96px;
			height: 96px;
		}
	}
`;

// Add styles to document
const style = document.createElement('style');
style.id = 'matm-boot-anim';
style.innerHTML = stylesheet;
const insertLocation = document.querySelector('script');
insertLocation.parentNode.insertBefore(style, insertLocation);

export function BootAnim() {
	useEffect(() => {
		return () => {
			const styleEl = document.getElementById('matm-boot-anim');
			if (styleEl && styleEl.parentNode) {
				try {
					styleEl.parentNode.removeChild(styleEl);
				} catch (error) {
					// eslint-disable-next-line no-console
					console.warn(`[BootAnim] Error removing style element:`, error);
				}
			}
		};
	}, []);

	return (
		<div className="matm-boot-anim-wrapper">
			<div className="matm-logo-container">
				<svg
					className="matm-logo-svg"
					width="384"
					height="384"
					xmlns="http://www.w3.org/2000/svg"
					version="1.1"
					viewBox="0 0 384 384"
				>
					<defs>
						<linearGradient
							id="matm_bg_gradient"
							spreadMethod="pad"
							x1="0"
							x2="1"
							y1="0"
							y2="1"
						>
							<stop offset="0" stopColor="#2d2f71" />
							<stop offset="0.2" stopColor="#2d2f71" />
							<stop offset="1" stopColor="#7a1544" />
						</linearGradient>
					</defs>
					<g className="matm-logo-paths">
						{/* First intersecting path */}
						<path
							d="m190.32,213.4l-2.35,2.35c-6.58,6.58 -17.25,6.58 -23.83,0c-6.55,-6.55 -6.57,-17.16 -0.08,-23.75c-6.49,-6.58 -6.47,-17.2 0.08,-23.74c6.58,-6.58 17.25,-6.58 23.83,0l23.75,23.74l-13.93,13.93l-4.11,-4.11l9.83,-9.83l-19.64,-19.64c-4.31,-4.31 -11.3,-4.31 -15.61,0c-4.31,4.31 -4.31,11.3 0,15.61l4.03,4.03l-4.03,4.03c-4.31,4.31 -4.31,11.3 0,15.61c4.31,4.31 11.3,4.31 15.61,0l2.35,-2.35l4.11,4.11"
							fill="#e1c9a0"
							fillRule="evenodd"
						/>
						{/* Second intersecting path */}
						<path
							d="m193.68,170.61l2.35,-2.35c6.58,-6.58 17.25,-6.58 23.83,0c6.55,6.55 6.57,17.16 0.08,23.74c6.49,6.58 6.47,17.2 -0.08,23.75c-6.58,6.58 -17.25,6.58 -23.83,0l-23.75,-23.75l13.93,-13.93l4.11,4.11l-9.83,9.83l19.64,19.64c4.31,4.31 11.3,4.31 15.61,0c4.31,-4.31 4.31,-11.3 0,-15.61l-4.03,-4.03l4.03,-4.03c4.31,-4.31 4.31,-11.3 0,-15.61c-4.31,-4.31 -11.3,-4.31 -15.61,0l-2.35,2.35l-4.11,-4.11"
							fill="#e1c9a0"
							fillRule="evenodd"
						/>
					</g>
				</svg>
			</div>
		</div>
	);
}
